import { AnonymousUser, User } from 'api/model'
import { atom } from 'recoil'

const authenticatedUserAtom = atom<User | null>({
  key: 'user',
  default: null,
})

const impersonatedUserAtom = atom<User | null>({
  key: 'impersonated_user',
  default: null,
})

const anonymousUserAtom = atom<AnonymousUser | null>({
  key: 'anonymous_user',
  default: null,
})

export { anonymousUserAtom, authenticatedUserAtom, impersonatedUserAtom }
